import React from "react";
import { XIcon } from "lucide-react";

import { useListContext } from "./List.hooks";

import { Button } from "@/components/ui/button";
import { cn } from "@/components/ui/utils";

export function ListCheckedItems<T>({
  children,
}: {
  children?: (item: T, index: number) => React.ReactNode;
}) {
  const {
    checkedData,
    uncheckedData,
    getRowKey,
    onSelectMultiSelectOption,
    setCheckedRows,
    classes,
  } = useListContext<T>();

  const handleUnselect = (itemToUnselect: T) => {
    setCheckedRows((prev) => {
      return {
        ...prev,
        [getRowKey(itemToUnselect)]: false,
      };
    });
  };

  if (checkedData.length === 0) return null;

  return (
    <div
      className={cn(
        "flex flex-wrap gap-1 p-2 pb-0 sticky top-0 z-2 bg-popover",
        classes.listItem,
        uncheckedData.length > 0
          ? "[border-bottom-width:1px] [border-bottom-style:solid]"
          : "[border-bottom-width:0] [border-bottom-style:none]",
        "border-border",
      )}
    >
      {checkedData.map((item, index) => {
        return (
          <div
            key={getRowKey(item)}
            onClick={() => {
              if (onSelectMultiSelectOption) {
                onSelectMultiSelectOption(item);
              } else {
                handleUnselect(item);
              }
            }}
            className={cn(
              "flex items-center justify-start rounded-md [border-width:1px] [border-style:solid] border-border",
              classes.listItem,
            )}
          >
            {children ? children(item, index) : <span>{String(item)}</span>}

            <Button
              variant="ghost"
              size="icon-xs"
              onClick={() => {
                handleUnselect(item);
              }}
            >
              <XIcon size={20} />
            </Button>
          </div>
        );
      })}
    </div>
  );
}
